export default __webpack_public_path__ + "static/media/LOGO-PRINCIPAL-V2.dfd61e21.png";